module.exports = __webpack_public_path__ + "static/media/icons_Bilan Entorse de cheville.b7c20ec4.svg";